var render = function render(_c,_vm){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","width":"20","height":"20"}},[_c('path',{attrs:{"fill":_vm.props.fillColor || 'currentColor',"d":"M19.188 19.188a1 1 0 0 1-1.358.052L10 11.41l-7.83 7.83a1 1 0 0 1-1.41-1.41L8.59 10 .76 2.17A1 1 0 0 1 2.17.76L10 8.59 17.83.76a1 1 0 0 1 1.41 1.41L11.41 10l7.83 7.83a1 1 0 0 1-.052 1.358z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }